import { render, staticRenderFns } from "./SendDocumentToSigningModal.vue?vue&type=template&id=7e4ddd54&"
import script from "./SendDocumentToSigningModal.vue?vue&type=script&lang=ts&"
export * from "./SendDocumentToSigningModal.vue?vue&type=script&lang=ts&"
import style0 from "./SendDocumentToSigningModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VForm,VIcon})
